import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import './styles.scss';

const ColorPaletteForm = ({
  items,
  onCopyLink,
  onPrev,
  onNext,
  shared,
  addToShare,
  removeShare,
  isLast,
}) => {

  return (
    <div>
      <p className="studio-share-modal__intro color-palette-share-modal__intro intro-text">
        Select the items you’d like to share below, and we’ll bundle them up for you to share via link or email.
        Recipients will always see the most current version of each item shared.
        Learn more about your sharing options{' '}
        <a
          href="https://help.aisleplanner.com/en/articles/2083600-sharing-style-guides-color-palettes
          -notes-with-vendors-outside-of-aisle-planner"
          target="_blank"
          rel="noreferrer"
        >
          here
        </a>
        .
      </p>
      <div className="color-palette-list">
        {items.length === 0 ? (
          <div className="empty-share-step">
            <p className="empty-share-step__text">
              It looks like you don’t have any color palettes to share just yet.
              Continue below to share other items you’ve selected.
            </p>
          </div>
        ) : (
          <>
            {items?.map(item => {
              const colors = item.palette?.colors || [];
              const len = colors?.length;
              const isShared = shared?.findIndex(data => data.id === item.id) > -1;

              return (
                <div
                  key={item.id}
                  className={clsx('color-palette-item', isShared && 'selected' )}
                  onClick={() => {
                    if (isShared) {
                      removeShare(item.id);
                    } else {
                      addToShare(item.id);
                    }
                  }}
                >
                  <p className="color-palette-item__title">{item.name}</p>
                  <section
                    className={clsx('color-palette-item__palette', !colors.len && 'no-colors')}
                  >
                    {colors?.map(color => (
                      <div
                        key={color}
                        className="color-palette-item__color"
                        style={{
                          width: `calc(100%/${len})`,
                          backgroundColor: `#${color}`,
                        }}
                      />
                    ))}
                  </section>
                </div>
              );
            })}
          </>
        )}
      </div>
      <div className="share-form__buttons">
        <button
          type="button"
          className="button"
          onClick={onPrev}
        >
          Back
        </button>
        {isLast && (
          <button
            type="button"
            className="button"
            onClick={onCopyLink}
          >
            Create Link
          </button>
        )}
        <button
          type="button"
          className="button"
          onClick={onNext}
        >
          Email
        </button>
      </div>
    </div>
  );
};

ColorPaletteForm.propTypes = {
  items: PropTypes.array,
  onCopyLink: PropTypes.func,
  onNext: PropTypes.func,
  shared: PropTypes.array,
  addToShare: PropTypes.func,
  removeShare: PropTypes.func,
};

ColorPaletteForm.defaultProps = {};

export default ColorPaletteForm;
